module.exports = __webpack_public_path__ + "static/media/backWave17.1060fcb4.svg";